import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/portal/managers/employment')({
  beforeLoad: () => {
    throw redirect({ to: '/portal/managers/hr/employees' });
  },
});
